<template>

  <div class="row">
    <div class="col-12">
      <div class="d-flex">
        <select id="" v-model="form.applies_to" :disabled="loading" name="applies_to" class="custom-select mr-1" style="min-width: 100px!important; width: 100px">
          <option value="">Alla sidor</option>
          <option v-for="page in pages" v-if="pages > 0" :key="page" :value="page">
            {{ 'Sida ' + page }}
          </option>
        </select>

        <div class="flex-grow-1">
          <textarea ref="textarea"
                    v-model="form.comment"
                    :disabled="loading"
                    :class="{'is-invalid' : hasError == 'comment' }"
                    rows="1"
                    placeholder="Kommentera"
                    class="form-control comment-input d-block pr-5"
                    @paste="onPaste"
          />
          <div class="invalid-feedback">
            Kommentarstexten får inte vara tom.
          </div>
        </div>

        <div class="" style="position: relative;">
          <button v-tooltip="$t('attach_files')" :disabled="loading" class="attach-btn">
            <label class="" title="Välj fil" for="customFile">
              <fa :icon="['far','paperclip']" fixed-width />
            </label>
            <input id="customFile" ref="files" type="file" class="d-none" multiple @change="setFile">
          </button>

        </div>

        <div>
          <button :disabled="loading" class="btn btn-primary ml-2 flex-grow-0" @click="saveComment">
            {{ loading ? 'Skickar kommentar...' : 'Kommentera' }}
          </button>
        </div>
      </div>
      <div class="col-12 d-flex">
        <small v-for="(att,index) in attachment" :key="index" class="mt-2 mr-3 d-flex align-items-center">
          {{ att.name }}

          <a href="#" class="text-danger ml-1" @click="removeAttachment(index)">
            <fa :icon="['fal','times']" />
          </a>
        </small>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import autosize from 'autosize'
import Form from 'vform'

export default {
  name: 'CommentForm',
  props: ['target', 'targetId', 'pages'],
  data () {
    return {
      loading: false,
      hasError: '',
      attachment: [],
      form: new Form({
        applies_to: '',
        comment: ''
      })
    }
  },
  mounted () {
    let area = this.$refs.textarea
    autosize(area)
  },
  methods: {
    doAutosize () {
      autosize(this.$refs.comment_text)
    },
    setFile (ev) {
      this.attachment = Array.from(ev.target.files)
    },
    removeAttachment (index) {
      this.attachment.splice(index, 1)
    },
    onPaste (e) {
      const items = (e.clipboardData || e.originalEvent.clipboardData).items

      const files = Array.from(items)
        .filter(item => item.kind === 'file')
        .map(item => item.getAsFile())

      if (files.length) {
        e.preventDefault()
        files.forEach(file => this.attachment.push(file))
      }
    },
    async saveComment () {
      if (this.form.comment == '') {
        this.hasError = 'comment'
      } else {
        this.hasError = ''
        this.loading = true

        let formData = new FormData()
        let params = Object.assign(this.form, {
          'target': this.target,
          'target_id': this.targetId,
          'type': 'comment'
        })

        for (var key in params) {
          formData.append(key, params[key])
        }
        if (this.attachment) {
          for (var i = 0; i < this.attachment.length; i++) {
            formData.append('attachment[' + i + ']', this.attachment[i])
          }
        }

        const { data } = await axios.post('/api/comment', formData)

        this.form.reset()
        this.attachment = null
        this.$emit('updateComments', data)

        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .attach-btn {
        background: transparent;
        border: none;
        z-index: 99;
        padding-right: .5rem;
        position: absolute;
        left: -2.5rem;
        top: .3rem;

        &:hover, &:hover svg, &:hover label {
            cursor: pointer;
        }
    }

    .comment-input {
        resize: none;
        overflow: hidden;
    }

    .custom-select {
        min-width: 150px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/CommentForm.vue